(() => {
  'use strict';
  const state = document.querySelector('[data-belunelle-offer-state]');
  if (!state || state.dataset.initialized) return;
  state.dataset.initialized = 'true';
  const deadline = Date.parse(state.dataset.deadline);
  const serverNow = Number(state.dataset.serverNow) * 1000;
  const started = performance.now();
  const banner = document.querySelector('[data-belunelle-offer]');
  let interval;
  let ended = false;
  let wasLive = false;
  const clock = banner ? {
    days: banner.querySelector('[data-offer-days]'),
    hours: banner.querySelector('[data-offer-hours]'),
    minutes: banner.querySelector('[data-offer-minutes]'),
    seconds: banner.querySelector('[data-offer-seconds]')
  } : null;
  const retire = () => {
    ended = true;
    if (banner) banner.hidden = true;
    document.documentElement.classList.add('belunelle-offer-retired');
    if (interval) window.clearInterval(interval);
    if (wasLive && banner) {
      // A page kept open still has its old product JSON. Offer a user-controlled
      // refresh, preserving the selected variant URL and the existing cart.
      const note = document.createElement('p');
      note.className = 'blo-ended';
      note.setAttribute('role', 'status');
      note.append('L’offre de la rentrée est terminée. ');
      const refresh = document.createElement('a');
      refresh.href = window.location.href;
      refresh.textContent = 'Actualiser les prix';
      note.append(refresh);
      banner.after(note);
    }
  };
  const update = () => {
    if (ended) return;
    // Absolute deadline: a revisit or background tab never starts a new offer.
    // The server anchor also prevents a slow device clock from extending it.
    const now = Math.max(Date.now(), serverNow + performance.now() - started);
    if (!Number.isFinite(deadline) || !Number.isFinite(now) || state.dataset.offerActive !== 'true' || now >= deadline) {
      retire();
      return;
    }
    wasLive = true;
    if (!clock) return;
    const remaining = Math.max(0, Math.floor((deadline - now) / 1000));
    const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining % 86400 / 3600), minutes: Math.floor(remaining % 3600 / 60), seconds: remaining % 60 };
    for (const [key, value] of Object.entries(values)) {
      const text = key === 'days' ? String(value) : String(value).padStart(2, '0');
      if (clock[key] && clock[key].textContent !== text) clock[key].textContent = text;
    }
  };
  update();
  if (!ended) interval = window.setInterval(update, 1000);
  document.addEventListener('visibilitychange', update);
  window.addEventListener('pageshow', update);
})();
